// Import and register all your controllers for Vite
import { application } from "./application"

// Import controllers
import HelloController from "./hello_controller"
import ChatMessagesController from "./chat_messages_controller"
import MessageInputController from "./message_input_controller"
import CollapsibleController from "./collapsible_controller"

// Register controllers
application.register("hello", HelloController)
application.register("chat-messages", ChatMessagesController)
application.register("message-input", MessageInputController)
application.register("collapsible", CollapsibleController)
